<script>
import { turpial } from '../../libraries/turpial.js';
import StripeCard from "tripod-styles/src/components/Elements/StripeCard.svelte";
import DlocalgoCheckbox from 'tripod-styles/src/components/Checkout/DlocalgoCheckbox.svelte';
import StripeCheckbox from 'tripod-styles/src/components/Checkout/StripeCheckbox.svelte';
import { PaymentProviderStore } from 'tripod-styles/src/components/Checkout/PaymentProviderStore.js';
import SimpleCheckbox from 'tripod-styles/src/components/Checkboxes/SimpleCheckbox.svelte';
import NotificationBox from 'tripod-styles/src/components/Notifications/NotificationBox.svelte';
import LoaderElement from 'tripod-styles/src/components/Others/LoaderElement.svelte';
import { random_string } from '../../libraries/random_string.js';
import { StoreForm } from './StoreForm.js';
import { AppForms } from '../../libraries/AppForms.js';
import { onMount } from 'svelte';
import PixelEventsHook from "tripod-styles/src/libraries/mybuilder/PixelEventsHook";
import { calculateRegionalPrice } from 'tripod-styles/src/libraries/regional_prices_calculator';
import { loadCurrencyRates, CurrenciesManagerStore } from 'tripod-styles/src/libraries/CurrenciesManagerStore';

export let changeStep;
export let Data;
export let errors;



let stripe_key;
Data.is_online = Data.is_online ?? true;
let metadata = Data;
let stripe_account = $StoreForm.global_vars.stripe_account;
let version_field = (Data.is_online === true) ? "live" : "test"
let force_payment_dlocalgo = Data.force_payment_dlocalgo ?? false;
let lang = Data.lang;
let Affiliate = Data.affiliate;
let trial = Data.trial ?? false;
let formLang = lang.forms.planSelection;
let purchase_events = Data?.purchase_events ?? [];
let selectedPrice;
let buttonSubmit = null;
let form = null;
let IS_ONLINE =  tripod_register.is_online ?? false;
let couponElement = null;
let plans;
let default_plan = Data.default_plan ?? null;
let default_to_set = null;

/**
 * Determina si se muestra o no el contenido html
 */
let show = false;
let quantity_option = 0;
quantity_option = window.quantity_option;

if(stripe_account === "account_v2"){
    stripe_key = $StoreForm.global_vars.stripeTokens_v2[version_field];
}else if(stripe_account === "account_v3"){
    stripe_key = $StoreForm.global_vars.stripeTokens_v3[version_field];
}else{
    stripe_key = $StoreForm.global_vars.stripeTokens[version_field];
}

if(force_payment_dlocalgo){
    PaymentProviderStore.setProvider("dlocalgo");
}


if(window.tripod_register.purchase_events) {
    window.tripod_register.purchase_events.event_data_store = {};
}

metadata.show_only_card = metadata.show_only_card ?? null;

if(typeof metadata.show_only_card === "string"){
    if(metadata.show_only_card !== "year" && metadata.show_only_card !== "month"){
        metadata.show_only_card = null;
    }
}


let _host = IS_ONLINE ? "https://app.3pod.io/" : "https://beta.3pod.io/";
let csrf_url = `${_host}cs_unique/user?v=3`;
let csrf_token = null;
window.addEventListener("message", function(event){
// Check sender origin to be trusted
    try {
        if (event.origin.search("app.3pod.io") < 0){
            return;
        }
        let data = event?.data ?? {};
        csrf_token = data?.tkcs ?? null;
    } catch (error) {
        
    }
}, false);

function sendEvent(){
    try {
        let dataRegister = $StoreForm.dataForm;
        dataRegister.userFromCampaign = tripod_register.userFromCampaign;
        dataRegister.user_from_campaign = tripod_register.user_from_campaign;
        dataRegister.add_trial_end = tripod_register?.add_trial_end ?? false;
        dataRegister.type_event = "Widget Registration";
        
        let url;
        if(IS_ONLINE === false){
            url = "http://localhost/beta.3pod.io/public/api/v1/events/registerUser";
        }else{
            url = "https://app.3pod.io/public/api/v1/events/registerUser";
        }
        turpial.fetch({
            url: [url],
            method: "POST",
            type: "text",
            data: JSON.stringify({
                token: btoa(JSON.stringify(dataRegister)).split("").reverse().join(""),
            }),
            ready: (data)=>{
                new PixelEventsHook("Contact", "fbq");
                new PixelEventsHook("Lead", "fbq");
                console.log("Lead 1!");
            }
        })
    } catch (error) {
        
    }
}
sendEvent();


$: {
    if(form !== null){
        if(typeof window.PaymentFunnelsMounted === "function"){
            window.PaymentFunnelsMounted(form);
        }
    }
}
let hasDiscountFromTag = false;
let activateCoupon = false;
if((Data?.activateCoupon ?? null) === true){
    activateCoupon = true;
}


let plan_id_selected = null;
let membership_type_selected = null;

function parsePlans(coupon){
    coupon = coupon ?? {};
    errors.hide();

    plans = $StoreForm.plansFetched.map(( plan )=>{
        const currencies_conversion = $CurrenciesManagerStore.currencies_conversion;
        const code_country = $StoreForm.dataForm.code_country || tripod_register.code_country || "";
        
        // Apply Regional Pricing Overrides & Fallback
        const regionalPriceData = calculateRegionalPrice(plan, code_country, currencies_conversion);
        if (regionalPriceData) {
            console.log(`Applying regional pricing for ${plan.name_plan} in Funnel:`, regionalPriceData);
            plan.price_plan = regionalPriceData.price_plan;
            plan.interval_year_price = regionalPriceData.interval_year_price;
            // Update Data.currency if it matches the plan's currency
            Data.currency = regionalPriceData.currency;
        }

        let price_month = plan.price_plan;
        let interval_year_price = plan.interval_year_price ?? plan.price_plan;
        let percent_off = 100-(interval_year_price*100)/price_month;
        percent_off = Number.parseInt(percent_off);
        let offPrice = (price_month-interval_year_price)*12;
        plan.prices = [];
        let yearChecked =  false;
        let discountPercent = 0;

        let currentPrices = {
            price_month: price_month,
            interval_year_price: interval_year_price,
        }
        let hasDiscountsPlan = false;
        if(typeof plan.discountsPlan !== "undefined"){
            discountPercent = +(plan.discountsPlan.discountPercent);
            if(discountPercent > 0){
                hasDiscountFromTag = true;
                price_month = price_month-((discountPercent/100)*price_month);
                interval_year_price = interval_year_price-((discountPercent/100)*interval_year_price);
                hasDiscountsPlan = true;
            }
        }
        if(typeof coupon.percent_off !== "undefined"){
            price_month = price_month-((coupon.percent_off/100)*price_month)
        }


        let to_push = {
            type: "month",
            is_default: false,
            percent_off: coupon?.percent_off ?? 0,
            hasDiscountsPlan: hasDiscountsPlan,
            name_plan: plan.name_plan,
            currentPrices: currentPrices,
            price_month: price_month,
            price_interval: price_month,
            real: price_month,
            yearly: price_month*12,
            globalDiscountPercent: discountPercent,
            id: "price-plan-"+random_string(6),
            checked: "checked='checked'",
        };

        if(default_plan !== null){
            if(typeof default_plan?.id !== "undefined" && default_plan?.interval !== "undefined"){
                if(default_plan.id === plan.__id__ && default_plan.interval === "month"){
                    to_push.is_default = true;
                    default_to_set = `input.is-checkradio[data-interval='month'][data-plan='${plan.__id__}']`;
                }
            }
        }

        plan.prices.push(to_push);


        

        plan_id_selected = plan.__id__;
        membership_type_selected = plan.membership_type;

        if(percent_off !== 0){
            yearChecked = true
            selectedPrice = interval_year_price; // price_interval

            if(typeof coupon.percent_off !== "undefined"){
                interval_year_price = interval_year_price-((coupon.percent_off/100)*interval_year_price)
            }

            let to_push = {
                type: "year",
                percent_off: coupon?.percent_off ?? 0,
                hasDiscountsPlan: hasDiscountsPlan,
                currentPrices: currentPrices,
                is_default: false,
                name_plan: plan.name_plan,
                price_month: interval_year_price,
                price_interval: interval_year_price,
                real: interval_year_price,
                yearly: interval_year_price*12,
                offPrice: offPrice,
                percent_off: percent_off,
                dont_pay: price_month*12,
                globalDiscountPercent: discountPercent,
                id: "price-plan-"+random_string(6),                
            }

            if(default_plan !== null){
                if(typeof default_plan?.id !== "undefined" && default_plan?.interval !== "undefined"){
                    if(default_plan.id === plan.__id__ && default_plan.interval === "year"){
                        to_push.is_default = true;
                        default_to_set = `input.is-checkradio[data-interval='year'][data-plan='${plan.__id__}']`;
                    }
                }
            }

            plan.prices.push(to_push)
        }

          
        return plan;
    })

    return plans;
}

parsePlans();
console.log(plans)
function updateDataForm(){
    // update any error
    errors.hide();

    let data = AppForms.retrieve({
        form: form,
        targets: ".formElements",
    })
    

    StoreForm.update("dataForm", data, $StoreForm.dataForm);
    data = $StoreForm.dataForm;
    return data;
}

let hasErrorForms = false;

function checkForm(data){
    let is_all_valid = true;
    data = data || {};

    // checks validation inputs.
    if(couponElement !== null){
        if(couponElement.dataset.valid === "false"){ is_all_valid = false; }
    }
    let checks = ["first-name", "last-name", "email", "password", "phone", "city"];
    // if payment provider is not dlocalgo
    if($PaymentProviderStore.provider_id !== "dlocalgo"){
        checks.push("card_name_owner");
    }
    
    // check empty inputs
    checks.map(( element )=>{
        if(typeof data[element] !== "string" && data[element] === ""){
            is_all_valid = false;
        }
    });

    
    
    return is_all_valid;
}

class generate_event_metadata
{
    constructor(plans, data)
    {
        let plan = plans.find((plan)=>{
            if(plan.__id__ === plan_id_selected){
                return plan;
            }
        })
        

        // SEND EVENT AND CONSTRUCT EVENT METADATA.
        let interval = data?.interval;
        
        let price = plan.prices.find((element)=>{
            if(element.type === interval){
                return element
            }
        })
        console.log(price)
        let final_price = interval === "year" ? (price.price_month * 12) : price.price_month;

        let event_data = {
            tag: (Data?.userFromCampaign ?? 'N/A'),
            percent_off: price?.percent_off ?? 0,
            email: data?.email ?? "",
            plan_id: plan_id_selected,
            interval: data?.interval ?? plan?.interval_selected ?? 'undefined-interval',
            name_plan: plan.name_plan,
            price_plan: final_price,
            membership: plan.membership_type,
        };

        return event_data;
    }
}
let payment_error = false;
let stripeToken = "";
function submitPayment(e){
    if(!e.submitter) {
        return;
    }

    let data = updateDataForm();
    let form_data = data;
    if(checkForm(data) === false){ 
        AppForms.statusButton(buttonSubmit, "enabled");
        errors.showError(lang.errors.uncompleted);
        return;
    }

    payment_error = false;
    AppForms.statusButton(buttonSubmit, "disabled");
    if ($PaymentProviderStore.provider_id === "dlocalgo") {
        data.payment_method = "dlocalgo";
        data.stripeToken = "dlocalgo";
        processPayment(data);
        return;
    }

    

    tripod_register.stripe.module.createToken(tripod_register.stripe.card).then(function(result) {
        if (result.error) {
            // Inform the user if there was an error.
            tripod_register.stripe.cardErrorElement.textContent = result.error.message;
            AppForms.statusButton(buttonSubmit, "enabled");
        } else {
            // Send the token to your server.
            // send data to server             
            data.stripeToken = result?.token?.id||"none";
            processPayment(data);
        }
    });
}

function processPayment(data) {
    data.affiliate = Affiliate;
    data.userFromCampaign = tripod_register.userFromCampaign||"widget-registration";
    data.add_trial_end = tripod_register?.add_trial_end ?? false;
    data.charge_products = tripod_register?.charge_products ?? [];
    data.referral_code = Data?.referral_code || null;
    
    data.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if(data.timezone === null){
        data.timezone = new Date().getTimezoneOffset();
    }
    if(data.timezone === null){
        try {
            data.timezone = "GMT"+new Date().toString().split("GMT")[1].split(" ")[0];
        } catch (error) {
            
        }
    }

    data.request = csrf_token;

    let url;
    let path = "public/api/v1/widget_customer_subscription";
    if(IS_ONLINE === false){
        url = `${Data?.host_offline ?? "http://localhost/beta.3pod.io/"}${path}`;
    }else{
        url = `https://app.3pod.io/${path}`;
    }

    let main_data = data;
    AppForms.statusButton(buttonSubmit, "disabled");
    turpial.fetch({
        url: [url],
        data: JSON.stringify(data),
        method: "POST",
        type: "text",
        ready: (data)=>{                    
            data = JSON.parse(data[0]);
            let message = data?.message ?? "";
            if(data?.status === "error"){
                errors.showError(message);
                AppForms.statusButton(buttonSubmit, "enabled");

                let error = JSON.stringify([data])
                throw new Error(`Error making request: ${error}`);
                return;
            }

            let redirect = data?.response?.url ?? data?.response?.redirect_url ?? null; 
            if(redirect === null){
                errors.showError(message);
                throw new Error(`Error on request: ${message}`);
                return;
            }
            if(typeof gtag !== "undefined"){
                try {
                    gtag('event', 'btn_sign_up_widget_register', {"send_to": "G-XEF7QBK3Z5", 'tag': (Data?.userFromCampaign ?? 'N/A'), 'user': main_data?.email ?? ""})
                    gtag('event', 'btn_sign_up_widget_purchase', {"send_to": "G-XEF7QBK3Z5"})
                    


                    let event_data = new generate_event_metadata(plans, $StoreForm.dataForm);

                    new PixelEventsHook("Purchase", "fbq", {currency: "USD", value: parseFloat(event_data.price_plan)});

                    try {
                        let on_register_event = window?.tripod_events?.on_register ?? null;
                        if(typeof on_register_event === "function"){
                            on_register_event(event_data);
                        }
                    } catch (error) {
                        console.error(error)
                    }
                    
                    try {
                        let on_purchase_events = window?.tripod_events?.on_purchase ?? null;
                        if(typeof on_purchase_events === "function"){
                            on_purchase_events(event_data);
                        }
                    } catch (error) {
                        console.error(error)
                    }
                } catch (error) {
                    console.error(error)
                }
            }
            setTimeout(() => {
                window.location.href = redirect;
            }, 2500);
        },
        onerror: (data)=>{
            console.error(data);
            payment_error = true;
            AppForms.statusButton(buttonSubmit, "enabled");
            

            throw new Error(`Error : Pago rechazado o ha ocurrido un error 500.`);
        }
    })
}
function getSelectedInterval(){
    let selected = form?.querySelector("input[name='interval']:checked");
    if(selected?.value === "year" || selected?.value === "month"){
        return selected.value;
    }

    if(metadata.show_only_card === "year" || metadata.show_only_card === "month"){
        return metadata.show_only_card;
    }

    return "month";
}

function checkCoupon(couponElement, button, interval = "month"){
    let input = couponElement;
    if(input.value === ""){
        input.classList.remove("coupon-success");
        input.classList.remove("coupon-error");
        input.dataset.valid = true;
        parsePlans();
        return;
    }
    
    if(input.value.length <= 3){
        input.classList.add("coupon-error");
        input.classList.remove("coupon-success");
        input.dataset.valid = false;
        parsePlans();
        return;
    }

    button.setAttribute("disabled", "");
    button.classList.add("is-loading");

    let coupon_value = input.value

    let url;
    if(IS_ONLINE === false){
        url = `http://localhost/beta.3pod.io/public/api/v1/getCoupon?coupon=${coupon_value}&interval=${interval}`;
    }else{
        url = `https://app.3pod.io/public/api/v1/getCoupon?coupon=${coupon_value}&interval=${interval}`;
    }

    fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            coupon: coupon_value,
            interval: interval
        })
    }).then((response) => response.json()).then((data) => {
        if(data?.status === "success"){
            input.classList.add("coupon-success");
            input.classList.remove("coupon-error");
            input.dataset.valid = true;

            parsePlans(data.response);

        }else{
            input.classList.add("coupon-error");
            input.classList.remove("coupon-success");
            input.dataset.valid = false;

            parsePlans();
        }
    }).catch((error) => {
        console.error(error)
        input.classList.add("coupon-error");
        input.classList.remove("coupon-success");
        input.dataset.valid = false;
        parsePlans();
    }).finally(() => {
        button.removeAttribute("disabled");
        button.classList.remove("is-loading");
    })
}

/**
 * 
 * @param {HTMLElement} box_element
 * @param {String} id_label
 */
function clicked_box(box_element, id_label){
    return;
    let boxes = [...form.querySelectorAll(".box-plan-column")];

    boxes.map(( /** @type {HTMLElement} */box )=>{
        box.classList.remove("is-active");
    })
    
    box_element.classList.add("is-active");

    let label = form.querySelector(`#${id_label}`);

    label.click();
}

let container_checkboxes = null;

function onBeforeSelect(option) {
    window.tripod_register.purchase_events.selected_item = option;
    validateFields();
}

function validateFields() {
    let store = window.tripod_register.purchase_events.event_data_store;
    let selected_item = window?.tripod_register?.purchase_events?.selected_item;
    let quantity = window.tripod_register.purchase_events.event_data_store[window?.tripod_register?.purchase_events?.selected_item]?.quantity;

    quantity_option = quantity;

    if(store[selected_item]?.quantity <= 0) {
        window.tripod_register.purchase_events.allow_purchase = false;
    }
    else{
        window.tripod_register.purchase_events.allow_purchase = true;
    }

    if(buttonSubmit !== null) {
        buttonSubmit.disabled = !window.tripod_register.purchase_events.allow_purchase;
    }
}

onMount(async () => {
    // Load currency rates using the shared library/store
    await loadCurrencyRates(Data.host);
    parsePlans();

    if(window?.tripod_register?.purchase_events?.items_select?.length > 0) {
        try{    
            if(typeof window?.tripod_register?.purchase_events?.onBeforeRender === "function") {
                await window.tripod_register.purchase_events.onBeforeRender();    
            }

            show = true;

            setTimeout(() => {
                validateFields();
            }, 0);
        }catch(error) {
            show = true;
            console.error("error al cargar las cupones del purchase_events: ", error);
        }
    }
    else{
        show = true;
    }
});

onMount(()=>{
    setTimeout(()=>{
        if(default_to_set !== null){
            let node = form.querySelector(default_to_set);
            if(node !== null){
                node.click();
            }
        }

        if(purchase_events?.items_select?.length > 0) {
            const firstItem = purchase_events?.items_select[0];
            firstItem.on_select = firstItem.on_select || function(){};

            window.tripod_register.purchase_events.selected_item = "purchase-events-1";
            firstItem.on_select();
        }
    },100)
});

</script>
{#if show}
    <header>
        <iframe src="{csrf_url}" title="tk" frameborder="0" class="is-sr-only"></iframe>
        <h2 class="has-text-black fw700 font-size-24 title-second-step">
            {@html formLang.title}
        </h2>
        <p class="fw500 font-size-16">
            {@html formLang.subtitle}
        </p>
        <p class="has-text-black fw700 subtitle-second-step font-size-24">
            <!--{@html formLang.subtitle}-->
            Paso 2 de 2
        </p>
    </header>
    <main class="pt-0 mt-0">
        <form action="" on:input|preventDefault="{ updateDataForm }" on:submit|preventDefault|stopPropagation="{ submitPayment }" bind:this="{form}">
            <div>
                <input type="hidden" name="stripeToken" value={stripeToken}>
                <input type="hidden" name="card_name_owner" value={stripeToken}>
                <input type="hidden" class="formElements" name="id_plan" bind:value="{plan_id_selected}">
                <input type="hidden" class="formElements" name="membership_type" bind:value="{membership_type_selected}">
            </div>
            {#if purchase_events?.items_select?.length > 0}
                {#if quantity_option <= 0}
                    <div class="notification-purchase-events">
                        <NotificationBox status="error">
                            <svelte:fragment slot="title">
                                <span class="has-text-dark font-size-16 fw600">
                                    Actualmente no hay fechas disponibles para este evento
                                </span>
                            </svelte:fragment>
                            <p class="has-text-grey font-size-14 fw400">
                                Si se libera algún cupo o abrimos nuevas fechas, te lo notificaremos directamente por correo
                            </p>
                        </NotificationBox>
                    </div>
                {/if}
            {/if}
            <div class="columns is-multiline is-marginless is-paddingless" bind:this={container_checkboxes}>
                {#each plans as plan}
                    <div class="column">
                        <checkboxes-plans class="columns is-multiline is-centered box-plan-container is-flex-touch" data-plan="{plan.name_plan}">
                            {#each plan.prices.filter((item, key)=>{
                                item.is_available = true;
                                item.selected_show_only_card = false;
                                if(metadata.show_only_card !== null){
                                    if(item.type !== metadata.show_only_card){
                                        item.is_available = false;
                                    }
                                    item.checked = true;
                                    item.selected_show_only_card = true;
                                }

                                if(item.is_available){
                                    return item;
                                }
                            }) as price_plan, key}
                                <!-- svelte-ignore a11y-click-events-have-key-events -->
                                <section class="column {!price_plan.is_default ? "":"is-active"} {plans.length <= 1 ? "is-6 is-6-tablet" : "is-12 is-12-tablet"} box-plan-column {metadata?.show_only_card ? 'show_only_card' : ""}"
                                    on:click|stopPropagation="{function(e){ clicked_box(e.currentTarget, price_plan.id); }}"
                                >
                                    <SimpleCheckbox has_circle={true} is_column={true} classes="pt-0 px-0">
                                        <input type="radio"
                                        checked={price_plan.checked||""} 
                                        name="interval"
                                        value="{price_plan.type}"
                                        on:change={(e)=>{ 
                                            selectedPrice = e.target.dataset.price; 
                                            membership_type_selected = plan.membership_type;
                                            plan_id_selected = plan.__id__;
                                        }}
                                        class="formElements">
                                        <svelte:fragment slot="content">
                                            <header class="header-element " style="padding: 10px 0;">
                                                <h2 class="font-size-16 fw600 py-alt-alt-2 is-capitalized">
                                                    {#if !price_plan.selected_show_only_card}
                                                            {formLang[price_plan.type] ?? "Mensual"}
                                                        {:else}
                                                            {lang.plan_text} {price_plan.name_plan}
                                                    {/if}
                                                    
                                                </h2>
                                            </header>
                                            <main class="content-checkbox-plan padding-x-20 pt-0">
                                                {#if price_plan.offPrice > 0}
                                                    {#if !price_plan.selected_show_only_card}
                                                        <discount-element class="has-text-success">
                                                            {formLang.headband} {price_plan.percent_off}%
                                                        </discount-element>
                                                    {/if}
                                                    
                                                    {:else}
                                                        <br>
                                                {/if}
                                                {#if !price_plan.selected_show_only_card}
                                                    <h2 class="fw700 font-size-24 has-text-black m-0">
                                                        {lang.plan_text} {price_plan.name_plan}
                                                    </h2>
                                                {/if}
                                                <!-- in case of show_only_card disabled set default -->
                                                {#if !price_plan.selected_show_only_card}
                                                    <price-element class="is-flex is-flex-direction-column">
                                                        <price-monthly class="font-size-24 fw600 has-text-black">
                                                            {Data.currency[0]}{Number.parseFloat(price_plan.price_month).toFixed(2)} <span class="font-size-16 fw500 has-text-black currency-data">{Data.currency[1]}/{formLang.intervals2.month}</span>
                                                        </price-monthly>
                                                        <price-yearly class="font-size-14 fw400">
                                                            {Data.currency[0]}
                                                            {Number.parseFloat(price_plan.yearly).toFixed(2)}{Data.currency[1]}/{formLang.intervals2.year}
                                                        </price-yearly>
                                                    </price-element>
                                                {/if}


                                                    <!-- in case of show_only_card ENABLED set variant design -->
                                                {#if price_plan.selected_show_only_card}
                                                    <price-element class="is-flex is-flex-direction-column">
                                                        {#if price_plan.type === "year"}
                                                            <price-yearly class="font-size-20 fw600 has-text-black">
                                                                {Data.currency[0]}{Number.parseFloat(price_plan.yearly).toFixed(2)} <span class="font-size-16 fw500 has-text-black currency-data">{Data.currency[1]}/{formLang.intervals2.year}</span>
                                                            </price-yearly>
                                                        {/if}
                                                        {#if price_plan.type === "month"}
                                                            <price-monthly class="fw600 has-text-black">
                                                                {Data.currency[0]}{Number.parseFloat(price_plan.price_month).toFixed(2)} <span class="font-size-16 fw500 has-text-black currency-data">{Data.currency[1]}/{formLang.intervals2.month}</span>
                                                            </price-monthly>
                                                            <price-yearly class="font-size-14 fw400">
                                                                {Data.currency[0]}
                                                                {Number.parseFloat(price_plan.yearly).toFixed(2)}{Data.currency[1]}/{formLang.intervals2.year}
                                                            </price-yearly>
                                                        {/if}
                                                    </price-element>
                                                {/if}
                                            </main>
                                        </svelte:fragment>
                                    </SimpleCheckbox>
                                </section>           
                            {/each}
                        </checkboxes-plans>
                    </div>
                {/each}
            </div>
            {#if purchase_events?.title?.length > 0 && purchase_events?.content?.length > 0}
                <div class="container-membership-gift mb-alt-4">
                    <span class="has-text-grey font-size-14 fw500">
                        {@html purchase_events?.title}
                    </span>
                    <span class="has-text-grey font-size-14 fw500">
                        {@html purchase_events?.content}
                    </span>
                </div>
            {/if}
            {#if purchase_events?.items_select?.length > 0}
                <span class="has-text-grey font-size-14 is-block has-text-left fw600">
                    Seleccionar fecha del evento
                </span>
                <div class="container-dates-purchase-events mt-alt-2">
                    {#each purchase_events?.items_select as item, index}
                        <SimpleCheckbox has_circle="{false}" is_column={false} style_checkbox_container={"height: 80px;"}>
                            <input type="radio" class="formElements" name="items-purchase_events" value="items-values-purchase_events" data-option="purchase-events-{index + 1}" checked={index === 0} on:change={(e) => {
                                onBeforeSelect(e.target.dataset.option);
                                item?.on_select();
                            }} data-array-input="true">
                            <svelte-fragment slot="content">
                                <div class="flex-column is-gap-5 full-width">
                                    <span class="has-text-grey font-size-14 fw600">
                                        {item?.title}
                                    </span>
                                    <span class="has-text-grey font-size-14 fw400">
                                        {item?.content}
                                    </span>
                                </div>
                            </svelte-fragment>
                        </SimpleCheckbox>    
                    {/each}
                </div>
                <span class="font-size-14 mt-alt-2 mb-alt-2 is-block has-text-left items-quantity-title fw400">
                    Quedan {quantity_option ?? 0} cupos disponibles para este fecha
                </span>
            {/if}
            <div class="columns is-multiline" style="padding: 1.45rem 0">
                {#if trial === false}
                    <div 
                        class="payment-methods-selection" 
                        class:is-sr-only={force_payment_dlocalgo}
                    >
                        {#if hasDiscountFromTag === false || activateCoupon === true}
                            <div class="field field-input has-addons is-align-items-flex-end column is-12 field-payment-funnels field-coupon is-12-touch">
                                <div class="control has-text-left full-width">
                                    <label for="" class="fw600 label-text">{formLang.coupon}</label>
                                    <input bind:this="{couponElement}" type="text" value="{$StoreForm?.dataForm["coupon"] ?? ""}" name="coupon" placeholder="{formLang.coupon}" class="input formElements coupon is-fullwidth" minlength="4">
                                </div>
                                <div class="control">
                                    <button type="button" on:click={function(e){ checkCoupon(couponElement, e.target, getSelectedInterval()) }} class="button is-primary is-marginless">
                                        {formLang?.coupon_apply ?? "Aplicar"}
                                    </button>
                                </div>
                            </div>
                        {/if}
                        <div class="field field-input column field-payment-funnels is-12-touch">
                            <div class="control has-text-left">
                                <label for="" class="fw600 label-text">Método de pago</label>
                                <div class="payment-methods-selection is-grid is-gap-20">
                                    <DlocalgoCheckbox 
                                        checked={$PaymentProviderStore.provider_id === "dlocalgo"}
                                        on:change={() => PaymentProviderStore.setProvider("dlocalgo")}
                                        name_input="payment_provider"
                                        country_set={$StoreForm?.dataForm?.code_country}
                                        is_online_context={IS_ONLINE}
                                        api_host={(Data?.host_offline ?? "http://localhost/beta.3pod.io/") + "api/v1/services/"}
                                    />
                                    <StripeCheckbox 
                                        checked={$PaymentProviderStore.provider_id === "stripe"}
                                        on:change={() => PaymentProviderStore.setProvider("stripe")}
                                        name_input="payment_provider"
                                    />
                                </div>
                            </div>
                        </div>
                        {#if $PaymentProviderStore.provider_id === "stripe"}
                            <div class="field field-input field-payment-funnels column is-12">
                                <div class="control has-text-left">
                                    <label for="" class="fw600 label-text">{formLang.card_name_owner}</label>
                                    <input type="text" value="{$StoreForm?.dataForm["card_name_owner"] ?? ""}" name="card_name_owner" placeholder="{formLang.card_name_owner}" class="input formElements is-fullwidth" minlength="4" required>
                                </div>
                            </div>
                        {/if}
                        {#if $PaymentProviderStore.provider_id === "stripe"}
                            <div class="field field-input column field-payment-funnels is-12 field-stripe-card is-12-touch">
                                <div class="control has-text-left">
                                    <label for="" class="fw600 label-text">{formLang.card}</label>
                                    <StripeCard stripe_key={stripe_key} />                    
                                </div>
                            </div>
                        {/if}
                    </div>
                {/if}            
                <div class="field field-payment-funnels column is-12">          
                    {#if payment_error}
                        <div class="error-message-3pod">
                            <p class="has-text-danger has-text-centered">
                                Su pago ha sido rechazado o ha ocurrido un error inesperado.  
                            </p>
                        </div>
                    {/if}
                    <div class="field field-input field-payment-agreement column is-12">
                        <div class="pb-alt-1">
                            <hr class="my-0">
                        </div>
                        <p class="has-text-left font-restricted-size-14 fw400 agree-terms-3pod">
                            {@html lang?.forms?.agree_payment}
                        </p>
                    </div>
                    <div class="buttons is-grouped is-centered">
                        <button bind:this={buttonSubmit} type="submit" class="button is-primary is-fullwidth">
                            {formLang.button}
                        </button>
                    </div>
                    <div class="navigation under--navigation-text">
                        <p class="is-underlined pointer under--navigation-back">
                            <!-- svelte-ignore a11y-click-events-have-key-events -->
                            <span on:click={changeStep("BasicForm")}>
                                {lang.goBack}
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </form>
    </main>
{:else}
    <div class="flex-center full-size">
        <LoaderElement message="" />
    </div>
{/if}

<style>
checkboxes-plans :global(checkradio-container header){
    background: transparent;
    border-bottom: 1px solid var(--color-extralightGrey);
    color: var(--color-primary);
    border-radius: 20px 20px 0 0;
}
checkboxes-plans :global(checkbox-radio), checkboxes-plans :global(checkradio-container){
    padding: 0px 0px 20px 0px !important;
    height: 100%;
}
checkboxes-plans :global(input[type='radio']:checked+checkradio-container header){
    border-bottom: 1px solid;
    border-radius: 8px 8px 0 0;
    background: var(--color-primary-gradient0);
    
}
checkboxes-plans :global(input[type='radio']:checked+checkradio-container header h2){
    color: #fff !important;
}
checkboxes-plans :global(checkbox-content){
    height: 100%;
    place-content: flex-end;
}

checkboxes-plans :global(checkbox-circle){
    opacity: 0;
    position: absolute;
    top: 0px;
}
.show_only_card .content-checkbox-plan {
    margin-top: 0 !important;
}
.show_only_card .header-element{
    margin-bottom: 0 !important;
}
main{
    margin-top: 1.25rem;
    padding-top: 1.25rem;
}
.coupon:global(.coupon-success), .coupon:global(.coupon-success:focus){
    border: 1px solid var(--color-green);
}
.coupon:global(.coupon-error), .coupon:global(.coupon-error:focus){
    border: 1px solid var(--color-red);
}
header{
    position: relative;
    margin-bottom: 1.25rem;
}
.box-plan-column price-monthly{
    font-size: 20px;
}
.box-plan-column.show_only_card price-monthly{
    font-size: 24px;
}
.box-plan-column.show_only_card{
    width: 100% !important;
}
@media only screen and (max-width:500px){
    .box-plan-container{
        flex-direction: column;
    }
    .box-plan-column{
        width: 100% !important;
    }
}
@media only screen and (max-width:768px){
    .field-payment-funnels{
        padding: 0.25rem 0.75rem;
    }
}
.box-plan-column:not(.is-active){
    cursor: pointer;
}
.box-plan-column:global(.is-active .box-plan){
    border: 1.25px solid var(--color-primary) !important;
}
.container-membership-gift {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 10px;
    background-color: rgba(41, 111, 255, 0.0588235294);
    padding: 20px 40px;
}
.container-dates-purchase-events {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 10px;
}
.notification-purchase-events {
    padding-left: 10px;
    padding-right: 10px;
    margin-bottom: 20px;
}
.items-quantity-title {
    color: var(--color-lightMidGrey);
}
</style>